import { ImportStatus, PERMISSION, APIError } from ".";

export enum CustomMeteoType {
  PREDEFINED_CAMS = "PREFEDINED_CAMS",
  CUSTOM = "CUSTOM",
}

export interface CustomMeteo {
  id: number;
  name: string;
  customMeteoType: CustomMeteoType;
  importStatus: ImportStatus;
  importErrors: APIError[];
  finalized: boolean;
  defaultValue: boolean;
  downloadUrl?: string;
  dateCreated: Date;
  linkedCases: { id: number; name: string }[];
  permissions: {
    update: PERMISSION;
    delete: PERMISSION;
    upload: PERMISSION;
    setDefault: PERMISSION;
  };
}
